var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-card-logo-container"},[_c('div',{directives:[{name:"bg-img",rawName:"v-bg-img",value:(_vm.creditCardLogoUrl),expression:"creditCardLogoUrl"}],staticClass:"logo"})])}
var staticRenderFns = []

export { render, staticRenderFns }